module.exports = __webpack_public_path__ + "img/nopicDe.98c8960b.png";